export default __webpack_public_path__ + "static/media/marker_filled_gray_light.b3f60b4b.svg";